import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Renderer2,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { StorageService } from 'ng-blockchainx';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CreateTokenContractService } from '../../services/create-token-contract.service';
import { CommonContractService } from 'src/app/shared/services/common-contract.service';
import Web3 from 'web3';

const STANDARD = 'standard';
const LIQUIDITY = 'liquidity';

interface TokenDetails {
  name: string | undefined;
  symbol: string | undefined;
  totalSupply: any | undefined;
  decimal: any | undefined;
}

@Component({
  selector: 'app-create-token',
  templateUrl: './create-token.component.html',
  styleUrls: ['./create-token.component.css'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class CreateTokenComponent implements OnInit {
  public tokenInfo: TokenDetails = {
    name: '',
    symbol: '',
    totalSupply: '',
    decimal: '',
  };
  public account: any;
  public isTokenTypeExpanded: boolean = false;
  public isDecimalDropdownExpanded: boolean = false;
  public isTokenCreated: boolean = false;
  public tokenDetails: any;
  public isDecimalExpanded: boolean = false;
  public isRouterExpanded: boolean = false;
  public selectTokenType: number = 0;
  public tokenTypes: any = ['Standard Token', 'Liquidity Generator Token'];
  public selectDecimalLabel: string = '6';
  public selectRouterName: string = '';
  public createTokenForm: FormGroup | any;
  public submitted: boolean = false;
  public standardTokenContract: any;
  public liquidityTokenContract: any;
  public createdTokenAddress: string = '';
  public transactionHash: string = '';
  public transactionUri: string = '';
  public standardFee: any;
  public standardFeeToDisplay: any;
  public liquidityFee: any;
  public liquidityFeeToDisplay: any;
  public processing: boolean = false;
  private routerAddress: string = '';
  public currentNativeCurrency: any = '-';
  public isMetamaskConnected: boolean = false;
  @ViewChild('toggleTokenButton', { static: true })
  toggleTokenButton!: ElementRef;
  @ViewChild('tokenMenu', { static: true })
  tokenMenu!: ElementRef;
  isCharityAddressInValid: boolean = false;
  isMarketingAddressInValid: boolean = false;
  metamaskObservable: any;
  accountObservable: any;
  public totalFee: number = 0;
  public addLiquidityFee: number = 0;


  constructor(
    private toastr: ToastrService,
    private createTokenContractService: CreateTokenContractService,
    private fb: FormBuilder,
    private storage: StorageService,
    private renderer: Renderer2,
    private _eref: ElementRef,
    private commonContractService: CommonContractService
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      /**
       * Only run when toggleButton is not clicked
       * If we don't check this, all clicks (even on the toggle button) gets into this
       * section which in the result we might never see the menu open!
       * And the menu itself is checked here, and it's where we check just outside of
       * the menu and button the condition abbove must close the menu
       */
      // if (e.target !== this.toggleTokenButton.nativeElement && e.target !== this.tokenMenu.nativeElement) {
      //   this.isTokenTypeExpanded = false;
      // }
    });
  }

  async ngOnInit() {
    if (this.storage.get('launchpad_active_menu')) {
      this.storage.remove('launchpad_active_menu');
    }
    this.storage.remove('active_menu');

    this.accountObservable =
      this.commonContractService.accountObservable.subscribe(
        async (res: string) => {
          if (res) {
            this.account = await res;
            this.transactionUri = transactionUri[this.account.chainId];

            // @dev recreating web3 connection with chainId(current)
            this.commonContractService.chainId = await this.account.chainId;
            await this.commonContractService.init();

            // initiating contract services
            await this.createTokenContractService.init();

            const standardFeeData =
              await this.createTokenContractService.getStandardFee();

            const liquidityFeeData =
              await this.createTokenContractService.getLiquidityFee();

            this.standardFee = standardFeeData.fee;

            this.liquidityFee = liquidityFeeData.fee;

            this.standardFeeToDisplay = standardFeeData.feeToDisplay;

            this.liquidityFeeToDisplay = liquidityFeeData.feeToDisplay;

            this.currentNativeCurrency = await this.commonContractService
              .currentNativeCurrency;
          }
        }
      );

    this.createTokenForm = this.fb.group({
      token_type: ['', Validators.required],
      decimal: ['', Validators.required],
      token_name: ['', [Validators.required, this.removeSpaces]],
      token_symbol: ['', [Validators.required, this.removeSpaces]],
      total_supply: ['', [Validators.required]],
      reflectionFee: [''],
      liquidityFee: [''],
      charityAddress: [''],
      charityFee: [''],
      marketingAddress: [''],
      marketingFeeToSell: [''],
      liquidityFeeToSell: [''],
      marketingFee: [''],
      charityFeeToSell: [''],
      transactionLimit: [''],
      router: [''],
    });
    this.createTokenForm.patchValue({ token_type: 0 });
    this.createTokenForm.patchValue({ decimal: 6 });

    const transactionUri: any = environment.transactionURI;

    this.metamaskObservable =
      this.commonContractService.isMetamaskConnectedObservable.subscribe(
        async (response: boolean) => {
          if (response) {
            this.isMetamaskConnected = response;
          }
        }
      );
  }

  charityAddressValidator(control: AbstractControl) {
    this.isWalletAddress(control.value, (charity: any) => {
      if (!charity) {
        this.isCharityAddressInValid = true;
      } else {
        this.isCharityAddressInValid = false;
      }
    });
  }

  marketingAddressValidator(control: AbstractControl) {
    this.isWalletAddress(control.value, (marketing: any) => {
      if (!marketing) {
        this.isMarketingAddressInValid = true;
      } else {
        this.isMarketingAddressInValid = false;
      }
    });
  }

  async isWalletAddress(walletAddress: string, cb: any) {
    const address = await this.createTokenContractService.isValidAddress(
      walletAddress
    );
    cb(address);
    return address;
  }

  /**
   * Select Token Type Dropdown
   */
  onSelectTokenType(type: number) {
    this.selectTokenType = type;
    this.isTokenTypeExpanded = !this.isTokenTypeExpanded;
    this.createTokenForm.patchValue({ token_type: type });

    const dynamicFields = [
      'reflectionFee',
      'liquidityFee',
      'charityAddress',
      'charityFee',
      'marketingAddress',
      'marketingFeeToSell',
      'liquidityFeeToSell',
      'marketingFee',
      'charityFeeToSell',
      'transactionLimit',
      'router',
    ];
    for (let i = 0; i < dynamicFields.length; i++) {
      const field = dynamicFields[i];
      if (type == 0) {
        this.createTokenForm.get(field).clearValidators();
      } else {
        this.createTokenForm
          .get(field)
          .addValidators([Validators.required, Validators.min(0)]);
        if (field == 'charityAddress') {
          this.createTokenForm.controls[field].addValidators(
            this.charityAddressValidator.bind(this)
          );
        }
        if (field == 'marketingAddress') {
          this.createTokenForm
            .get(field)
            .addValidators(this.marketingAddressValidator.bind(this));
        }
      }
      this.createTokenForm.controls[field].updateValueAndValidity();
    }
  }

  /**
   * Select Decimal Dropdown
   */
  onSelectDecimal(name?: string) {
    this.isDecimalExpanded = !this.isDecimalExpanded;
    if (name) {
      this.selectDecimalLabel = name;
      this.createTokenForm.patchValue({ decimal: name });
    }
  }

  /**
   * Router Dropdown
   */
  onSelectRouter(name?: string, type?: string) {
    this.isRouterExpanded = !this.isRouterExpanded;
    if (name) {
      this.selectRouterName = name;
      if (this.account.chainId == '0x61') {
        if (type == 'PANCAKE_SWAP') {
          // BSC Testnet
          this.routerAddress =
            environment.CONTRACT_ADDRESS['0x61'].PANCAKE_SWAP;
        } else {
          this.routerAddress = environment.CONTRACT_ADDRESS['0x61'].SUSHI_SWAP;
        }
      } else if (this.account.chainId == '0x38') {
        if (type == 'PANCAKE_SWAP') {
          // BSC Mainnet
          this.routerAddress =
            environment.CONTRACT_ADDRESS['0x38'].PANCAKE_SWAP;
        } else {
          this.routerAddress = environment.CONTRACT_ADDRESS['0x38'].SUSHI_SWAP;
        }
      } else if (this.account.chainId == '0x152') {
        // CRONOS Testnet
        this.routerAddress = environment.CONTRACT_ADDRESS['0x152'].PHOTON_SWAP;
      } else if (this.account.chainId == '0x19') {
        // CRONOS Mainnet
        this.routerAddress = environment.CONTRACT_ADDRESS['0x19'].PHOTON_SWAP;
      } else if (this.account.chainId == '0x13881') {
        // Polygon Testnet
        if (type == 'QUICK_SWAP') {
          this.routerAddress =
            environment.CONTRACT_ADDRESS['0x13881'].QUICK_SWAP;
        } else {
          this.routerAddress =
            environment.CONTRACT_ADDRESS['0x13881'].SUSHI_SWAP;
        }
      } else if (this.account.chainId == '0x89') {
        // Polygon Mainnet
        if (type == 'QUICK_SWAP') {
          this.routerAddress =
            environment.CONTRACT_ADDRESS['0x89'].QUICK_SWAP;
        } else {
          this.routerAddress =
            environment.CONTRACT_ADDRESS['0x89'].SUSHI_SWAP;
        }
      } else if (this.account.chainId == '0xfa2') {
        // Fantom Testnet
        this.routerAddress = environment.CONTRACT_ADDRESS['0xfa2'].SPOOKY_SWAP;
      } else if (this.account.chainId == '0xfa') {
        // Fantom Mainnet
        this.routerAddress = environment.CONTRACT_ADDRESS['0xfa'].SPOOKY_SWAP;
      } else if (this.account.chainId == '0x5') {
        // Ethereum Testnet
        if (type == 'UNI_SWAP') {
          this.routerAddress = environment.CONTRACT_ADDRESS['0x5'].UNI_SWAP;
        } else {
          this.routerAddress = environment.CONTRACT_ADDRESS['0x5'].SUSHI_SWAP;
        }
      } else if (this.account.chainId == '0x1') {
        // Ethereum Mainnet
        if (type == 'UNI_SWAP') {
          this.routerAddress = environment.CONTRACT_ADDRESS['0x1'].UNI_SWAP;
        } else {
          this.routerAddress = environment.CONTRACT_ADDRESS['0x1'].SUSHI_SWAP;
        }
      } else if (this.account.chainId == '0xa869') {
        // Avalanche Testnet
        // if (type == 'PANGOLIN_SWAP') {
        //   this.routerAddress = environment.CONTRACT_ADDRESS["0xa869"].PANGOLIN_SWAP
        // } else {
        this.routerAddress = environment.CONTRACT_ADDRESS['0xa869'].SUSHI_SWAP;
        // }
      } else if (this.account.chainId == '0xa86a') {
        // Avalanche Mainnet
        this.routerAddress = environment.CONTRACT_ADDRESS['0xa86a'].SUSHI_SWAP;
      } else if (this.account.chainId == '0x507') {
        // Moonbase Testnet
        this.routerAddress = environment.CONTRACT_ADDRESS['0x507'].SOLARBEAM;
      } else if (this.account.chainId == '0x504') {
        // Moonbeam Mainnet
        this.routerAddress = environment.CONTRACT_ADDRESS['0x504'].SOLARBEAM;
      }
      this.createTokenForm.patchValue({ router: name });
    }
  }

  toggleToken() {
    this.isTokenTypeExpanded = !this.isTokenTypeExpanded;
  }

  /**
   * getter function
   */
  get f() {
    return this.createTokenForm.controls;
  }

  /**
   * Create token form submit
   */
  public createTokenFormSubmit() {
    this.submitted = true;
    if (this.createTokenForm.valid) {
      this.createTokenForm.disable();
      if (this.selectTokenType == 0) {
        this.createStandardToken(); // create standard ERC20 token
      } else {
        if (!this.isCharityAddressInValid && !this.isMarketingAddressInValid) {
          this.createLiquidityToken(); // create liquidity token
        } else {
          this.toastr.error('Please provide valid details');
        }
      }
    } else {
      this.toastr.error('Please fill all required fields');
      this.createTokenForm.enable();
    }
  }

  /**
   * create standard ERC20 token
   */
  public async createStandardToken() {
    if (!this.account) {
      this.processing = false;
      this.toastr.error('Connect metamask to continue');
      return;
    }
    this.processing = true;
    this.tokenInfo.name = this.createTokenForm.value.token_name;
    this.tokenInfo.symbol = this.createTokenForm.value.token_symbol;
    this.tokenInfo.totalSupply = this.createTokenForm.value.total_supply;
    this.tokenInfo.decimal = this.createTokenForm.value.decimal;
    const createTokenAbi = await this.createTokenContractService.createAbi(
      this.createTokenForm.value.token_name,
      this.createTokenForm.value.token_symbol,
      this.createTokenForm.value.decimal,
      this.createTokenForm.value.total_supply,
      STANDARD
    );
    const token: any = await this.createTokenContractService
      .createToken(
        this.account.walletAddress,
        createTokenAbi,
        this.standardFee,
        STANDARD
      )
      .catch((error: any) => {
        this.processing = false;
        if (error.data?.code === 4001) this.toastr.error('User Rejected');
        else this.toastr.error(error.data.message);
        this.createTokenForm.enable();
      });
    if (token) {
      this.createTokenForm.enable();
      this.processing = false;
      this.createdTokenAddress = token.data.logs[1].address;
      this.transactionHash = token.data.transactionHash;
      this.isTokenCreated = true;
    }
  }

  /**
   * create liquidity token
   */
  public async createLiquidityToken() {
    if (!this.account) {
      this.processing = false;
      this.toastr.error('Connect metamask to continue');
      return;
    }
    this.processing = true;
    this.tokenInfo.name = this.createTokenForm.value.token_name;
    this.tokenInfo.symbol = this.createTokenForm.value.token_symbol;
    this.tokenInfo.totalSupply = this.createTokenForm.value.total_supply;
    this.tokenInfo.decimal = this.createTokenForm.value.decimal;
    const createLiquidityTokenAbi =
      await this.createTokenContractService.createAbi(
        this.createTokenForm.value.token_name,
        this.createTokenForm.value.token_symbol,
        this.createTokenForm.value.decimal,
        this.createTokenForm.value.total_supply,
        LIQUIDITY,
        this.routerAddress
      );
    const token: any = await this.createTokenContractService
      .createToken(
        this.account.walletAddress,
        createLiquidityTokenAbi,
        this.liquidityFee,
        LIQUIDITY
      )
      .catch((error: any) => {
        this.processing = false;
        if (error.data?.code === 4001) this.toastr.error('User Rejected');
        else this.toastr.error(error.data.message);
        this.createTokenForm.enable();
      });
    if (token) {
      this.createTokenForm.enable();
      this.createdTokenAddress = token.data.logs[1].address;
      this.transactionHash = token.data.transactionHash;

      const initializeTokenFeesAbi =
        await this.createTokenContractService.initiateTokenFeeAbi(
          this.createdTokenAddress,
          this.createTokenForm.value.reflectionFee,
          this.createTokenForm.value.liquidityFee,
          this.createTokenForm.value.liquidityFeeToSell,
          this.createTokenForm.value.marketingFee,
          this.createTokenForm.value.marketingFeeToSell,
          this.createTokenForm.value.marketingAddress,
          this.createTokenForm.value.charityFee,
          this.createTokenForm.value.charityFeeToSell,
          this.createTokenForm.value.charityAddress,
          this.createTokenForm.value.transactionLimit
        );
      const initializeTokenFees = await this.createTokenContractService
        .initiateLiquidityTokenFees(
          this.account.walletAddress,
          initializeTokenFeesAbi
        )
        .catch((error: any) => {
          this.processing = false;
          if (error.data?.code === 4001) this.toastr.error('User Rejected');
          else this.toastr.error(error.data.message);
          this.createTokenForm.enable();
        });
      if (initializeTokenFees) {
        this.totalFee = +this.createTokenForm.value.reflectionFee+ +this.createTokenForm.value.liquidityFee+ +this.createTokenForm.value.charityFee+ +this.createTokenForm.value.marketingFee;
        this.addLiquidityFee = this.createTokenForm.value.liquidityFee;
        this.processing = false;
        // this.createTokenForm.reset();
        // Object.keys(this.createTokenForm.controls).forEach(key => {
        //   this.createTokenForm.get(key).setErrors(null);
        // });
        this.isTokenCreated = true;
      }
    }
  }

  /**
   * redirect to launchpad page with created token details
   */
  public redirectToLaunchpad() {
    window.location.href =
      window.location.origin + '/launchpad?token=' + this.createdTokenAddress;
  }

  /**
   * open transaction explorer page in new tab
   */
  public openTXPage() {
    window.open(this.transactionUri + this.transactionHash, '_blank');
    console.log('uri', this.transactionUri);
  }

  /**
   * function to copy address to clipboard
   */
  public copyAddress() {
    navigator.clipboard.writeText(this.createdTokenAddress).then((value) => {
      this.toastr.success('Token address copied successfully');
    });
  }

  onClick(event: any) {
    if (!this._eref.nativeElement.contains(event.target)) {
      // or some similar check
      this.isTokenTypeExpanded = false;
      this.isDecimalDropdownExpanded = false;
    }
  }

  /**
   * Dropdown Close
   * @param {string} type
   */
  close(type: string) {
    switch (type) {
      case 'token':
        this.isTokenTypeExpanded = false;
        break;
      case 'router':
        this.isRouterExpanded = false;
        break;
      case 'decimal':
        this.isDecimalExpanded = false;
        break;
    }
  }
  removeSpaces(control: AbstractControl) {
    if (control && control.value && !control.value.replace(/\s/g, '').length) {
      control.setValue('');
    }
    return null;
  }

  connectWallet() {
    this.commonContractService.enableMetaMaskConnection(true);
  }

  async ngOnDestroy() {
    this.metamaskObservable?.unsubscribe();
    this.accountObservable?.unsubscribe();
    // this.commonContractService.metamaskObservable?.unsubscribe()
  }
}
